import config from '@/config';
import useNavigateToArtwork from '@/hooks/useNavigateToArtwork';
import useQuery from '@/hooks/useQuery';
import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';
import Utils from '@/utils';

import SearchVirtualList from './components/SearchVirtualList';

import './index.css';

export default function SearchResults({ query }) {
  const { loading, queryData, loadMoreData } = useQuery("main_search", `${config.apis.api.url}/search/artwork`, query, {
    injectToken: true,
    customKeyGetter: {
      artist: (currentValue) => currentValue.map(item => item._id),
      gallery: (currentValue) => currentValue.map(item => item._id),
      price: (currentValue) => currentValue ? [currentValue.minPrice, currentValue.maxPrice === 50000 ? Number.MAX_SAFE_INTEGER : currentValue.maxPrice] : null,
    }
  });
  const navigateToArtwork = useNavigateToArtwork(`main_search`, queryData?.data, `/search/artwork${queryData?.queryString}`);
  
  if (loading) {
    return <Loader />;
  } else {
    return (
      <>
        <Text className="search-results__results-count" large>
          {Utils.numberWithCommas(queryData.data.totalDocs)} 

          {" "}results{" "} 

          {query.q && (
            <span>
              for "<span className="search-results__results-count-query">{query.q}</span>"
            </span>
          )}
        </Text>
    
        {
          queryData.data.data.length === 0 ? 
            <Text className="search-results__no-results" small>
              No results match your search query.
            </Text>
            :
            <SearchVirtualList 
              key={queryData.queryString} 
              items={queryData.data} 
              onLoadMore={loadMoreData}
              navigateToArtwork={navigateToArtwork}
            />
        }
      </>
    );
  }
}
